import { Fetcher } from '@this/src/util';

import type { ShareholderTicketFeeArgs } from '@this/domain/shareholder_ticket_fee/shareholder_ticket_fee';

export interface FetchShareholderTicketFeesParams {
  organizationId: string;
  fromCode: string;
  toCode: string;
  airline: string;
}

const ALL_ORGANIZATION_ID = '0';

interface ShareholderTicketFeesRequestParams {
  organization_id: string;
  from_code?: string;
  to_code?: string;
  airline?: string;
}

interface ShareholderTicketFeesResponse {
  shareholder_ticket_fees: ShareholderTicketFeeArgs[];
}

export const fetchShareholderTicketFees = (params: FetchShareholderTicketFeesParams) => {
  const requestParams: ShareholderTicketFeesRequestParams = {
    organization_id: params.organizationId || ALL_ORGANIZATION_ID
  };
  if (params.fromCode) requestParams.from_code = params.fromCode;
  if (params.toCode) requestParams.to_code = params.toCode;
  if (params.airline) requestParams.airline = params.airline;

  return Fetcher.get<ShareholderTicketFeesResponse>('/arrangement/shareholder_ticket_fees.json', requestParams);
};
